import { capitalize, pick } from "lodash";
import React, { memo } from "react";
import RenderWhen from "../../../components/RenderWhen";

import { getURLGridQueryParams } from "../../../utils";
import { LOCATION } from "../consts";
import {
  getSelectionPresentationKey,
  getSelectionPresentationValue
} from "./utils";

interface Props {
  history: string;
  queryClassname?: string;
}

const SearchHistoryItem = ({ history, queryClassname }: Props) => {
  const {
    searchQuery,
    selections,
    filters: { location }
  } = pick(getURLGridQueryParams(history), [
    "searchQuery",
    "selections",
    "filters"
  ]);

  return (
    <>
      <span className={queryClassname} title={searchQuery}>
        {searchQuery}
      </span>
      <div className="flex flex-column">
        {Object.entries(selections || {}).map(
          ([key, value]: [string, string], index) => (
            <span key={index}>{`${getSelectionPresentationKey(
              key
            )}: ${getSelectionPresentationValue(key, value)}`}</span>
          )
        )}
        <RenderWhen
          condition={[LOCATION.CLOUD, LOCATION.NETWORK].includes(location)}
        >
          <span>Location: {capitalize(location)}</span>
        </RenderWhen>
      </div>
    </>
  );
};

export default memo(SearchHistoryItem);
